import React, { useMemo } from "react";
import "./TimeLine.css";
import TodoList from "./TodoList/TodoList";
import CalendarTasks from "./CalendarTasks/CalendarTasks";

const TimeLine = ({ events, selectedDate }) => {
  const { appointments, todos } = useMemo(() => {
    const appointments = [];
    const todos = [];
    events.forEach((event) =>
      (event.category === 1 ? todos : appointments).push(event)
    );
    return { appointments, todos };
  }, [events]);

  return (
    <div className="calender-tasks">
      <TodoList todos={todos} />
      <CalendarTasks selectedDate={selectedDate} appointments={appointments} />
    </div>
  );
};

export default TimeLine;
